import { COUNTRIES_PHONE_FORMAT, CountryWithPhoneFormat } from 'config';

export const formatPhoneGeo = (inputNumbers: string) => {
  const { countryCode } =
    COUNTRIES_PHONE_FORMAT[CountryWithPhoneFormat.Georgia]!;

  let formattedInputValue = `${countryCode} `;

  if (inputNumbers.length === 1) {
    formattedInputValue = `${formattedInputValue}${inputNumbers.substring(
      0,
      1,
    )}`;
  }
  if (inputNumbers.length >= 4) {
    formattedInputValue = `${formattedInputValue}${inputNumbers.substring(
      3,
      6,
    )}`;
  }
  if (inputNumbers.length >= 7) {
    formattedInputValue = `${formattedInputValue} ${inputNumbers.substring(
      6,
      8,
    )}`;
  }
  if (inputNumbers.length >= 9) {
    formattedInputValue = `${formattedInputValue} ${inputNumbers.substring(
      8,
      10,
    )}`;
  }
  if (inputNumbers.length >= 11) {
    formattedInputValue = `${formattedInputValue} ${inputNumbers.substring(
      10,
      12,
    )}`;
  }

  return formattedInputValue;
};
